import * as React from 'react';

import type { Libp2pContextValue } from './types';

export const Libp2pContext = React.createContext<Libp2pContextValue | null>(
  null,
);
